import { RouteHandler } from 'wee-routes';
import $ from 'wee-dom';
import $events from 'wee-events';
import { _body } from 'core/variables';
import KeyHelper from '../../scripts/keyhelper';
import Video from '../video-popup';

export default new RouteHandler({
    init() {
        const video = new Video($(':locationVideo'));

        window.onYouTubeIframeAPIReady = function onYouTubeIframeAPIReady() {
            video.player = new YT.Player('player');
        }

        $events.on({
            [video.$controls.sel]: {
                click(e, el) {
                    if (video[$(el).data('event')]()) {
                        video[$(el).data('event')]()
                    }
                }
            },
            window: {
                keyup(e) {
                    if (KeyHelper.isEsc(e) && video.isOpen) {
                        video.close();
                    }
                }
            }
        });
    }
});
